import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const resources = {
    'en': { translation: require('./i18n/en.json') },
    'it': { translation: require('./i18n/it.json') },
    'sl': { translation: require('./i18n/sl.json') },
}

i18n
    // detect user language
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    .init({
        debug: false,
        fallbackLng: 'en',
        // lng: 'th',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources
    });

export default i18n;